import { Spin } from "antd";
import React from "react";
const LoaderCard = ()=> {

    return <div style={{ height: 'calc(100vh - 200px)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Spin /></div>
}

export default LoaderCard;